import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';
import PageHeaderStowagePlanItem from './PageHeaderStowagePlanItem';
import { getStowagePlanType } from 'src/utils/stowage/stowagePlanUtils';
import { ReactNode } from 'react';
import { StowagePlanListItemTitle } from './PageHeaderStowage.style';

interface StowagePlanListGroupProps {
    stowagePlan: StowagePlan;
    onClick?: (event, plan: StowagePlan) => void;
}

const PageHeaderStowagePlanListItem = ({ stowagePlan, onClick }: StowagePlanListGroupProps): ReactNode => {
    if (!stowagePlan) return <StowagePlanListItemTitle>No master plan for this vessel...</StowagePlanListItemTitle>;

    const stowagePlanType = getStowagePlanType(stowagePlan);

    return (
        <span className="dd-item" key={stowagePlan.stowagePlanGuid} onClick={(e) => onClick && onClick(e, stowagePlan)}>
            <PageHeaderStowagePlanItem stowagePlan={stowagePlan} stowagePlanType={stowagePlanType} />
        </span>
    );
};

export default PageHeaderStowagePlanListItem;
